import { render } from "./ListBody.vue?vue&type=template&id=f343b304"
import script from "./ListBody.vue?vue&type=script&lang=js"
export * from "./ListBody.vue?vue&type=script&lang=js"
script.render = render

export default script